module.exports = __webpack_public_path__ + "img/050-mauritania.f7f3f21e.svg";